export enum DistanceUnits {
  MILES = 'mi',
  KILOMETERS = 'km',
  METERS = 'm',
}
